import store from 'redux/store';
import { setContext, setSubContext } from 'modules/common/actions';

const initApp = (context, subContext) => {
  store.dispatch(setContext(context));
  store.dispatch(setSubContext(subContext));
};

export default initApp;
